export default __webpack_public_path__ + "static/media/gps.b485c805.svg";